import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Headers } from '@angular/http';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AutoPanelCreation } from 'src/app/model/auto-panelCreation-module/auto-panel-creation';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AutoPanelCreationService {

  constructor(private http: Http, private apiService: ApiService) { }
  private apiDomain = ApiService.getDomainName();

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    dateOfInterview: new FormControl(''),
    fromTime: new FormControl(''),
    toTime: new FormControl(''),
    panelCnt: new FormControl('', [Validators.required, Validators.minLength(1)]),
    panelMemberCntPerPanel: new FormControl('', [Validators.required, Validators.minLength(1)]),
    candidateCntPerPanel: new FormControl('', [Validators.required, Validators.minLength(1)]),
  });

  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }


  autoPanelCreation(autoPanelCreation: AutoPanelCreation, processId): any {
    let autoPanelCreationHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    let dataObj = JSON.stringify(autoPanelCreation);
    return this.http.post(this.apiDomain + "/ims/api/" + processId + "/panels", dataObj, { headers: autoPanelCreationHeaders })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
}
